import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadConfig } from './utils/runtimeConfig';
import appConfig from './config/appConfig';
import './styles/variables.css';
import './styles/layout.css';
import '@progress/kendo-theme-default/dist/all.css';



// Load runtime config (/config.json) and the global app settings (assistant /
// maintenance, from the settings service) before rendering. Both fail
// gracefully if unavailable — the app falls back to env vars / defaults.
Promise.allSettled([loadConfig(), appConfig.loadServerSettings()]).finally(() => {
    ReactDOM.createRoot(document.getElementById('root')).render(
        //<React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        //</React.StrictMode>
    );
});
